import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import React from "react";

import Spacer from "../Spacer/Spacer";
import injectStores from "components/RootStore/injectStores";
import { RouterStore } from "stores/RouterStore";
import RootStore from "stores/RootStore";
import { Tooltip } from "components/Tooltip";
import { CloseDialogButton } from "components/Button";

interface DialogHeaderProps {
  routerStore?: RouterStore;
  rootStore?: RootStore;
}

interface Tab {
  title: string;
  icon: React.ReactNode;
}

const DialogHeader: React.FC = injectStores((props: DialogHeaderProps) => {
  const { routerStore } = props;

  const {
    renderDialog,
    dialogEnableDraggable,
    renderDialogTab,
    dialogSetActiveTab,
    forceFullScreenDialog,
    toggleForceFullScreenDialog,
  } = routerStore;
  if (!renderDialog) return null;

  const { title, tabs, closeButton = true } = renderDialog;

  return (
    <Toolbar
      sx={{
        cursor:
          dialogEnableDraggable && !forceFullScreenDialog ? "move" : "default",
        backgroundColor: "secondary.main",
      }}
      id={forceFullScreenDialog ? undefined : "draggable-dialog-title"}
    >
      {title && (
        <Tooltip
          title={
            forceFullScreenDialog ? "Exit Full Screen" : "Enter Full Screen"
          }
        >
          <h4
            onClick={() => toggleForceFullScreenDialog()}
            style={{
              color: "white",
              cursor: forceFullScreenDialog ? "zoom-out" : "zoom-in",
            }}
          >
            {title}
          </h4>
        </Tooltip>
      )}
      <Spacer />
      {tabs && Array.isArray(tabs) && tabs?.length > 0 && renderDialogTab && (
        <>
          <Tabs
            value={renderDialogTab.activeTabIndex}
            variant="scrollable"
            aria-label="app tabs"
            // classes={{
            //   indicator: classes.tabIndicator,
            // }}
          >
            {tabs.map((tab, index) => {
              return (
                <Tab
                  onClick={() => dialogSetActiveTab(index)}
                  style={{
                    color:
                      renderDialogTab.activeTab === tab.title
                        ? "white"
                        : "gray"[2],
                  }}
                  key={tab.title}
                  icon={
                    typeof tab.icon === "string" ||
                    React.isValidElement(tab.icon)
                      ? tab.icon
                      : undefined
                  }
                  label={tab.title}
                />
              );
            })}
          </Tabs>
          <Spacer />
        </>
      )}
      <Tooltip
        title={
          forceFullScreenDialog ? "Exit Full Screen" : "Enter Full Screen"
        }
      >
        <IconButton
          size="small"
          onClick={() => toggleForceFullScreenDialog()}
          sx={{ color: "white", mr: 0.5 }}
          aria-label={forceFullScreenDialog ? "Exit fullscreen" : "Fullscreen"}
        >
          {forceFullScreenDialog ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
      </Tooltip>
      {closeButton && <CloseDialogButton />}
    </Toolbar>
  );
});

export default DialogHeader;
